import api from "./api";

export const getMyFavorites = (page = 1) =>
  api.get("/my-favorites", { params: { page } }).then((res) => res.data);

export const toggleFavorite = (eventId) =>
  api.post(`/favorites/${eventId}/toggle`).then((res) => res.data);
